import { z } from 'zod'

export const examinationFormSchema = (t: (key: string) => string) =>
  z
    .object({
      height_cm: z
        .string()
        .min(1, t('donor_detail.medical_history.validation.height_required')),
      weight_kg: z
        .string()
        .min(1, t('donor_detail.medical_history.validation.weight_required')),
      blood_pressure_systolic: z
        .string()
        .min(
          1,
          t(
            'donor_detail.medical_history.validation.pressure_systolic_required',
          ),
        ),
      blood_pressure_diastolic: z
        .string()
        .min(
          1,
          t(
            'donor_detail.medical_history.validation.pressure_diastolic_required',
          ),
        ),
      pulse: z
        .string()
        .min(1, t('donor_detail.medical_history.validation.pulse_required')),
      // Optional; the range only rejects unrealistic values (backend answers
      // 422 outside 30–45 °C). An abnormal reading is a warning, not an error.
      temperature_c: z.string().refine((value) => {
        if (value.trim() === '') return true
        const temperature = Number(value)
        return (
          Number.isFinite(temperature) && temperature >= 30 && temperature <= 45
        )
      }, t('donor_detail.medical_history.validation.temperature_range')),
      conclusion: z
        .string()
        .min(
          1,
          t('donor_detail.medical_history.validation.conclusion_required'),
        ),
      needs_ambulatory_exam: z.boolean(),
      referral_organization_id: z.string(),
    })
    .refine(
      (data) => {
        const systolic = Number(data.blood_pressure_systolic)
        const diastolic = Number(data.blood_pressure_diastolic)

        if (!Number.isFinite(systolic) || !Number.isFinite(diastolic)) {
          return true
        }

        return systolic > diastolic
      },
      {
        message: t(
          'donor_detail.medical_history.validation.pressure_systolic_greater_than_diastolic',
        ),
        path: ['blood_pressure_systolic'],
      },
    )

export type ExaminationFormValues = z.infer<
  ReturnType<typeof examinationFormSchema>
>
